package com.milta.core.localization.translations.bg

import com.milta.core.localization.LoadingAddressStrings

internal val LoadingAddress = LoadingAddressStrings(
    title = "Адрес за товарене",
    emptyMessage = "За да оптимизирате курса, посочете къде вашите шофьори товарят стоките. Адресът ще бъде запазен за следващите ви курсове.",
    selectPlaceholder = "Изберете адрес за товарене",
    sheetSubtitle = "Мястото, където вашите шофьори вземат стоките.",
    startPointBadge = "Начална точка",
    newAddressAction = "Нов адрес",
    mobileSearchPlaceholder = "Улица, номер, населено място",
    webSearchPlaceholder = "Търсене на адрес…",
    deleteDialogTitle = "Изтриване на този адрес?",
    deleteDialogMessage = "„%s“ вече няма да се предлага. Вече създадените курсове не се променят.",
    webSubmitBlockedHint = "Изберете адрес за товарене, за да оптимизирате.",
    errorRequired = "Изберете адрес за товарене.",
)
